module.exports = __webpack_public_path__ + "img/faq-candidates.6a30dc82.svg";